import { createStore } from '@toolkit/store-generator';
import type { Issues } from '@feature/shared/form';
import Shared from '@feature/shared';

import { type Newsletter, Base } from './newsletter.schema';

const store = createStore<Issues>({});

const validate = (data: Newsletter) => {
  return Shared.Form.validate(Base, data, store);
};

const submit = async (data: Newsletter) => {
  try {
    await Shared.Repo.send('/newsletter', data);
  } catch (error) {
    Shared.Error.setPermenantError('There was an error submitting your details, please try again.');
    console.error(error);
    throw error;
  }
};

export { validate, submit, store, type Issues };
